<picture>
  <source srcset="/simply-pos.webp" type="image/webp" media="(prefers-color-scheme: light)">
  <source srcset="/simply-pos-dark.webp" type="image/webp" media="(prefers-color-scheme: dark)">
  <img src="/simply-pos.png" alt="Simply POS - Kassensysteme & Bildschirme" class="logo" />
</picture>

<div class="login-container" [class.keyboard-open]="showKeyboard()">
  <form [formGroup]="loginForm" (ngSubmit)="onSubmit()">
    <mat-card [appearance]="'outlined'">
      <mat-card-header>
        <span matCardTitle>{{customerName() ?? '...'}}</span>
      </mat-card-header>
      <mat-card-content>
        <mat-form-field appearance="outline" [class.active-field]="activeField() === 'email'">
          <mat-label>{{ 'login.emailLabel' | translate }}</mat-label>
          <input #emailInput matInput formControlName="email" type="email"
            [placeholder]="'login.emailPlaceholder' | translate"
            (focus)="onFieldFocus('email')"
            (click)="onFieldClick('email')"
            (input)="onFieldInput('email')">
          @if (loginForm.get('email')?.hasError('required')) {
          <mat-error>{{ 'login.emailRequiredError' | translate }}</mat-error>
          }
          @if (loginForm.get('email')?.hasError('email')) {
          <mat-error>{{ 'login.emailInvalidError' | translate }}</mat-error>
          }
        </mat-form-field>

        <mat-form-field appearance="outline" [class.active-field]="activeField() === 'password'">
          <mat-label>{{ 'login.passwordLabel' | translate }}</mat-label>
          <input #passwordInput matInput formControlName="password" [type]="showPassword() ? 'text' : 'password'"
            [placeholder]="'login.passwordPlaceholder' | translate"
            (focus)="onFieldFocus('password')"
            (click)="onFieldClick('password')"
            (input)="onFieldInput('password')">
          <button
            mat-icon-button
            matSuffix
            type="button"
            (mousedown)="$event.preventDefault()"
            (click)="togglePasswordVisibility($event)"
            [attr.aria-label]="(showPassword() ? 'login.hidePassword' : 'login.showPassword') | translate"
            [attr.aria-pressed]="showPassword()">
            <mat-icon>{{ showPassword() ? 'visibility_off' : 'visibility' }}</mat-icon>
          </button>
          @if (loginForm.get('password')?.hasError('required')) {
          <mat-error>{{ 'login.passwordRequiredError' | translate }}</mat-error>
          }
        </mat-form-field>

        @if (errorMessage()) {
        <div role="alert">
          <mat-icon>error</mat-icon>
          <p>
            {{ errorMessage()! | translate }}
          </p>
        </div>
        }

      </mat-card-content>
      <mat-card-actions>
        <button mat-flat-button type="submit" [disabled]="loginForm.invalid || isLoading()">{{
          'login.submitButton' | translate
          }}
        </button>
      </mat-card-actions>
    </mat-card>
  </form>

  <button mat-stroked-button type="button" class="keyboard-toggle" (click)="toggleKeyboard()">
    <mat-icon>keyboard</mat-icon>
    {{ showKeyboard() ? 'Tastatur ausblenden' : 'Tastatur einblenden' }}
  </button>
</div>

<!-- Virtual Keyboard -->
<sp-virtual-keyboard
  [inputValue]="keyboardValue()"
  [visible]="showKeyboard()"
  [inputElement]="activeInputElement()"
  (valueChange)="onKeyboardValueChange($event)"
  (enterPressed)="onKeyboardEnter()"
  (closeKeyboard)="onKeyboardClose()">
</sp-virtual-keyboard>

<footer sp-footer></footer>
